<template>
	<div>
		<div class="title-container">
			<div class="title"><span class="fa fa-tags"></span>Manage Categories</div>
			<div class="buttons">
				<router-link to="/commerce/products/list" class="button"><div class="hover-title">Go Back</div><span class="fa fa-chevron-left"></span></router-link>
			</div>
		</div>

		<form @submit.prevent="addCategorySubmit" action>
			<div class="search-container">
				<div class="input-box"><input placeholder="Type Name Here" type="text" v-model="addForm.name"></div>
				<div class="search-icon"><span class="fa fa-plus"></span></div>
			</div>
		</form>

		<div v-if="categories.length === 0" class="list-container">
			<div class="table">
				<nothing-here></nothing-here>
			</div>
		</div>

		<div class="conjoin-input-containers">
			<form v-for="category in sortedCategories" :key="`category-${ category.id }`" action @submit.prevent="editCategorySubmit(category.id)" class="input-container">
				<div class="input-box"><input type="text" :ref="`edit_${category.id}`" v-model="editForm[category.id].name" @focus="editCategory(category)"></div>

				<div v-if="isEditing(category)" class="inline-buttons">
					<a v-if="isEditing(category)" href @click.prevent="editCategorySubmit(category.id)"><div class="hover-title">Save Changes</div><span class="fa fa-save"></span></a>
					<a v-if="isEditing(category)" href @click.prevent="cancelEdit(category.id)"><div class="hover-title">Cancel</div><span class="fa fa-undo"></span></a>
				</div>

				<div v-if="isConfirmingDelete(category)" class="inline-buttons">
					<a v-if="isConfirmingDelete(category)" href @click.prevent="confirmDelete(category)"><div class="hover-title">Confirm Delete</div><span class="fa fa-trash"></span></a>
					<a v-if="isConfirmingDelete(category)" href @click.prevent="$set(editForm[category.id], 'deleting', false)"><div class="hover-title">Cancel</div><span class="fa fa-undo"></span></a>
				</div>

				<div v-if="!isEditing(category) && !isConfirmingDelete(category)" class="inline-buttons">
					<a v-if="!isEditing(category) && !isConfirmingDelete(category)" href @click.prevent="editCategory(category)"><div class="hover-title">Update</div><span class="fa fa-pencil"></span></a>
					<a v-if="!isEditing(category) && !isConfirmingDelete(category)" href @click.prevent="clickDelete(category)"><div class="hover-title">Delete</div><span class="fa fa-trash"></span></a>
				</div>
				<button type="submit" style="display:none;"></button>
			</form>
		</div>
	</div>
</template>

<script>

import _ from 'underscore';

export default {

	name: 'CommerceProductCategoriesPage',

	async asyncData({ app }) {
		const { data } = await app.$api.get(`/commerce/categories`);

		const editForm = {};
		data.data.forEach(category => {
			editForm[category.id] = { ...category, editing: false };
		});

		return {
			categories: data.data,
			editForm,
		};
	},

	data() {
		return {
			categories: [],
			addForm: {},
			editForm: {},
		};
	},

	computed: {

		sortedCategories() {
			return [ ...this.categories ].sort((a, b) => {
				if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
				if (b.name.toLowerCase() > a.name.toLowerCase()) return -1;

				return 0;
			});
		},

	},

	methods: {

		async addCategorySubmit() {
			const { data } = await this.$api.post(`/commerce/categories`, {
				name: this.addForm.name,
			});

			this.categories.unshift(data);
			this.$set(this.editForm, data.id, { ...data, editing: false });

			this.$store.dispatch('addToast', `Added ${this.addForm.name}`);
			this.addForm = {};
		},

		isEditing(category) {
			return !!this.editForm[category.id].editing;
		},

		isConfirmingDelete(category) {
			return !!this.editForm[category.id].deleting;
		},

		editCategory(category) {
			this.$set(this.editForm[category.id], 'editing', true);
			this.$nextTick(() => {
				this.$refs[ `edit_${category.id}` ][ 0 ].focus();
			});
		},

		clickDelete(category) {
			this.$set(this.editForm[category.id], 'deleting', true);
		},

		cancelEdit(categoryId) {
			this.$set(this.editForm[categoryId], 'editing', false);
			let index = _.findIndex(this.categories, { id: categoryId });
			if (index !== -1) this.$set(this.editForm[categoryId], 'name', this.categories[index].name);
		},

		async editCategorySubmit(categoryId) {
			const { data } = await this.$api.put(`/commerce/categories/${categoryId}`, {
				name: this.editForm[categoryId].name,
			});

			let index = _.findIndex(this.categories, { id: categoryId });
			if (index !== -1) this.categories[ index ] = data;

			this.$store.dispatch('addToast', `${this.editForm[categoryId].name} Updated`);
			this.$set(this.editForm[categoryId], 'editing', false);
		},

		async confirmDelete(category) {
			try {
				await this.$api.post(`/commerce/categories/${category.id}/delete`);

				this.$store.dispatch('addToast', `${category.name} Deleted`);
				const index = _.findIndex(this.categories, category);

				if (index !== -1) {
					this.categories.splice(index, 1);
				}
			} catch (e) {
				this.$store.dispatch('errorToast', 'There was a problem deleting that category. Please try again soon.');
			}
		},

	},
};

</script>
